import axios from 'src/utils/axios';

// CON-1518 — Event Template Types registry actions.
//
// Reference data fetched once on login and cached in Redux. The
// registry describes every active templateType (label, subtext,
// gateField, hasAttachment, supportsContactCard, senderRole, channel,
// sortOrder) so view layers don't need to hardcode this metadata. See
// the eventTemplateTypes table seeded by migration
// 20260504130000-create-event-template-types-registry.js.

// ── Action Types ──

export const GET_EVENT_TEMPLATE_TYPES = '@event-template-types/get-list';
export const GET_EVENT_TEMPLATE_TYPES_SUCCESS = '@event-template-types/get-list-success';
export const GET_EVENT_TEMPLATE_TYPES_ERROR = '@event-template-types/get-list-error';

// ── Action Creator ──

/** *************************************************************************
 * getEventTemplateTypes
 *
 * Fetches the registry. Fired non-blocking on login from Auth.js. On
 * error, dispatches GET_EVENT_TEMPLATE_TYPES_ERROR — never throws.
 * Login UX must not be degraded by a slow registry endpoint.
 *************************************************************************** */
export const getEventTemplateTypes = () => async (dispatch) => {
  dispatch({ type: GET_EVENT_TEMPLATE_TYPES });
  try {
    const response = await axios.get('/api/eventTemplateTypes');
    const eventTemplateTypes = Array.isArray(response?.data?.eventTemplateTypes)
      ? response.data.eventTemplateTypes
      : [];
    dispatch({
      type: GET_EVENT_TEMPLATE_TYPES_SUCCESS,
      payload: { eventTemplateTypes },
    });
  } catch (error) {
    dispatch({
      type: GET_EVENT_TEMPLATE_TYPES_ERROR,
      payload: { error: error?.message || 'Failed to load event template types' },
    });
  }
};
